<template>
    <cell :is-import-modal="isImportModal">
        <data-field v-if="column.entity"
                    :calculated-by="field.calculated_by"
                    :is-import-modal="isImportModal"
                    :formula="column.entity.getFormula(field.key)"
                    :is-editing="column.isEditing"
                    :is-formula-editable="field.is_formula_editable"
                    :percent="column.isLocked ? column.entity.getPercent(field.key) : column.entity.percent(field.key)"
                    :value="column.isLocked ? column.entity.getValue(field.key) : column.entity.value(field.key)"
                    @input="setValue(field, column, $event)"
        />
    </cell>
</template>

<script>
import DataField from '@/Components/Storemanager/DataField';
import CalculatedBy from '@/Enums/CalculatedBy';
import FieldConfiguration from '@/Models/FieldConfiguration';
import Cell from '@/Components/Storemanager/Column/Cell';
import DataColumn from '@/Components/Storemanager/Entities/DataColumn';

export default {
    components: {Cell, DataField},

    props: {
        column: {
            type: DataColumn,
            required: true,
        },
        field: {
            type: FieldConfiguration,
            required: true,
        },
        isImportModal: {
            type: Boolean,
            default: false,
            required: false
        },
    },

    methods: {
        setValue(field, column, value) {
            if (field.calculated_by === CalculatedBy.VALUE) {
                column.entity.setValue(field.key, value);
            } else if (field.calculated_by === CalculatedBy.PERCENT) {
                column.entity.setPercent(field.key, value);
            } else {
                column.entity.setFormula(field.key, value);
            }
        },
    },
};
</script>
